import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import { useForm } from "react-hook-form";
import { PrismicRichText } from '@prismicio/react';

export const BusinessCardSuccess = ({ slice, index }) => {
  const [piwikVisitorId, setPiwikVisitorId] = useState("unknown");
  const [isSend, setSend] = useState(false);
  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { register, setValue, handleSubmit, watch, formState: { errors, isSubmitted } } = useForm({
    mode: "onChange"
  });

  const {title, subtitle, text_1, text_2} = slice.primary

  useEffect(() => {
    if (typeof window !== 'undefined' && window._paq) {
        var _paq = window._paq || [];
        _paq.push([function() {
        setPiwikVisitorId(this.getVisitorId());
        }]);
    }
  }, []);

  useEffect(() => {
      if (typeof window !== 'undefined'){
        const params = new URLSearchParams(window.location.search.substring(1));
        const item_name = params.get("package");
        const price = Number(params.get("price"));      
  
      // create a new datalyer, or let it be empty
          window.dataLayer = window.dataLayer || [];
  
      //reset datalayer if length greater than 150, otherwise might cause issues
      if(window.dataLayer.length >150){
          window.dataLayer = []
  
          // this is how the documentation says to flush the datalayer, but is not working
          // so using the above line where dataLayer = []
  
          /*window.dataLayer.push(function() {
              this.reset();
          })*/
      }
  
      if (item_name && price) {
        //console.log("Package: ", item_name)
        //console.log("Price: ", price)
        window.dataLayer.push({
          event: "purchase",
          ecommerce: {
            currency: "EUR",
            value: price,
            items: [
              {
                item_name: item_name,
                price: price,
                currency: "EUR",
              }
            ]
          }
        });
      }
    }}, []);

  const isFirst = index === 0;

  const onSubmit = async (data) => {
    const url = "https://n8n.yohn.io/webhook/business_card_success";
    const formData = new FormData();
    formData.append('companyLogo', data.companyLogo[0]);
    if (data.headshot && data.headshot[0]) {
      formData.append('headshot', data.headshot[0]);
    }
    formData.append('text', data.text);
    formData.append('piwikVisitorId', piwikVisitorId);

    setLoading(true);
    let response = null;
    try {
      const options = {
        method: 'POST',
        mode: 'cors', // no-cors, *cors, same-origin
        redirect: 'follow',
        body: formData,
      };

      response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }

      const json = await response.json();
      if (json && json.success === true) {
        setError(false);
      } else {
        setError(true);
      }
    } catch (e) {
      const status = response ? response.status : null;
      const message = e.message || 'Error';
      setError(true);
      console.error({ success: false, message, status });
    }
    setSend(true);
    setLoading(false);
  }

  if (isLoading && !isSend) {
    return (
      <div className="container py-6 text-center">
        {isFirst ? <h1 className="h2 text-center mb-5">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
        <div className="text-center">
          <div className="loader mx-auto"></div>
        </div>
      </div>
    );
  }

  if (isSend) {
    return (
      <div className="container py-6 text-center">
        <div className="text-center col-12 mx-auto">
          {!isError && (
          <>
            <h2 className="mb-4">Thank you – you're all set!</h2>
            <p>We've received your details – and we're already getting to work on your premium digital business card and mini-website!</p>
            <p>You can expect to see your card in your inbox within the next 24 hours (but let’s be honest... we usually deliver in 6 hours or less).</p>
            <p>Thanks again for choosing us – we can’t wait to show you your new digital business card!</p>
            <p>In the meantime, if you have any questions or additional requests, please, click the button below.</p>
            <div className="mt-4">
              <a href="https://www.yohn.io/contact-us/" className={"btn btn-sm text-uppercase btn-primary"}>{"CONTACT YOHN"}</a>
            </div>
          </>
          )}
          {isError && (
          <>
            <h3>An error has occurred</h3>
            <p>Please try again later, server is not available now.</p>
            <div className="col-auto">
              <button onClick={()=>setSend(false)} className={"btn btn-sm text-uppercase btn-primary"}>{"Try again"}</button>
            </div>
          </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="container py-6 text-center">
      {isFirst ? <h1 className="h2 my-4 text-center">{title}</h1> : <h2 className="my-4 text-center">{title}</h2>}
      <h4 className="text-center">{subtitle}</h4>
      <div className="text-start">
        <div className="text-center">
          <PrismicRichText field={text_1.richText} />
        </div>
        <div className="col-12 col-md-9 col-lg-6 mx-auto mt-5">
          <form id="business_card_success" className="text-center" onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label class="form-label fw-bold">Company logo</label>
              <input
                type="file"
                class="form-control"
                {...register('companyLogo', {required: true})}
              />
            </div>
            <div className={"mt-4"}>
              <label class="form-label fw-bold">Your headshot photo <span className="fw-normal">(optional)</span></label>
              <input
                type="file"
                class="form-control"
                {...register('headshot')}
              />
            </div>
            <div className={"mt-4"}>
              <label class="form-label fw-bold">Additional business information <span className="fw-normal">(optional)</span></label>
              <textarea
                id="text"
                type="text"
                rows="5"
                placeholder="Additional phone numbers or email addresses, company name, job title, office address, social media links that you would like your business card to contain"
                className={'form-control' + " " + (errors.email && isSubmitted ? "is-invalid" : "")}
                {...register('text')}
              />
              {errors.email && isSubmitted && <div className="invalid-feedback">{'Invalid email address'}</div>}
            </div>
            <input type="submit" value="Submit" className={"w-100 mt-4 btn btn-sm btn-primary text-uppercase"}/>
          </form>
        </div>
        <div className="mt-5 text-center">
          <PrismicRichText field={text_2.richText} />
        </div>
      </div>
      <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2228540&vkey=af99ef8d1d876ce680303044f46f1971" />
    </div>
  )
}

export const query = graphql`
  fragment PageDataBodyBusinessCardSuccess on PrismicPageDataBodyBusinessCardSuccess {
    primary {
      title
      text_1 {
        richText
      }
      text_2 {
        richText
      }
    }
  }
`
